import { render, staticRenderFns } from "./VippPage.vue?vue&type=template&id=6f7240d1"
import script from "./VippPage.vue?vue&type=script&lang=js"
export * from "./VippPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports